import { mockCustomerType } from './MockCustomerProducts';

export const mockCustomer = async () => {
	await new Promise((resolve) => setTimeout(resolve, 250));
	switch (mockCustomerType) {
		case -1:
			return mockUnknownCustomer_;
		default:
			return mockCustomer_;
	}
};

const mockCustomer_ = {
	customer_id: '0000000001',
	businessbrand: '339996a3-4df2-4230-bfe9-3051a98500cb',
	account_list: [
		{
			account_id: '0000000001',
			alt_account_id: '00000001',
			source_system: 'CodanTIA',
		},
	],
	tags: '#private #customer #insurance #CodanTIA',
	name: 'mock-customer@clients',
	person: {
		person_id: '0000000001',
		cpr_nr: '0101900000',
		firstname: 'Ida',
		lastname: 'Testkunde',
		roles: [],
	},
	contact: {
		address: {
			street_number: '4',
			street_name: 'Ejby Alle',
			building_no_and_letter: '4',
			postal_code: 2650,
			city_name: 'Hvidovre',
		},
		contact_details: [
			{
				detail: '4',
				type: 'Street_Number__c',
			},
			{
				detail: 'Hvidovre',
				type: 'City__c',
			},
			{
				detail: '001000000000001AAA',
				type: 'Account_18_character_ID__c',
			},
			{
				detail: 'PRIVATE',
				type: 'Customer_Type__c',
			},
			{
				detail: 'Ida',
				type: 'FirstName',
			},
			{
				detail: '00000000',
				type: 'Mobile__c',
			},
			{
				detail: '2650',
				type: 'Postal_Code__c',
			},
			{
				detail: 'Testkunde',
				type: 'LastName',
			},
			{
				detail: 'Ejby Alle',
				type: 'Street__c',
			},
			{
				detail: 'ida.testkunde@example.com',
				type: 'Email__c',
			},
			{
				detail: 'Ida Testkunde',
				type: 'Name',
			},
		],
	},
	consent: [],
};

const mockUnknownCustomer_ = {
	account_list: [],
	tags: '#unknown #NotABGroupCustomer',
	name: 'mock-unknown-customer@clients',
	consent: [],
};
